import React from 'react';
import './styles.scss';

type OptionButtonViewProps = {
    onClick: (e: React.MouseEvent) => void;
    text: string;
    title?: string;
    icon: React.ReactNode;
    hidden?: boolean;
    className?: string;
    danger?: boolean;
}

const OptionButtonView = ({onClick, text, title, icon, hidden, className = "", danger }: OptionButtonViewProps) => {

    if(hidden){
        return null;
    }

    return (
        <div title={title} className={`option-button ${danger ? "option-button--danger" : ""} ${className}`} onClick={onClick}>
            {icon}
            <span>
                {text}
            </span>
        </div>
    );
}

export default OptionButtonView;
